module.exports = __webpack_public_path__ + "static/img/package.d4b9ec0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/package.png
// module id = M0Mm
// module chunks = 1